import React from "react"
import { Link } from "@wfp/ui"

function AboutRpme() {
  return (
    <div className="p-3">
      <div className="mb-2">
        <h3 className="pb-1">What is the RPME? </h3>
        <p className="border-solid border-black border-2 p-1 mb-1">
          The RPME process is a systematic review of retailers throughout the contract period that aims to verify and
          track how well and how consistently the retailer is meeting agreed-upon performance targets.
        </p>

        <ul className="list-disc mb-1 leading-6 list-inside pl-6">
          <li>
            The approach relies upon a <b>semi-standardized survey</b> and digital methodology to consistently evaluate
            retailers.
          </li>
          <li>
            This includes corporate performance evaluation criteria (mandatory and optional), while it also enables the
            inclusion of the <b>country and context-specific questions.</b>
          </li>
          <li>
            The approach is valid both for <b>Value and Commodity Vouchers</b> and it is adaptable for specific
            mechanisms.
          </li>
        </ul>

        <p className="mb-1">
          Retailers Performance is computed into a performance score that is the consolidation of a score assigned per
          each <b>key performance evaluation areas:</b> (1) Assortment and Availability, (2) Price, (3) Food Safety and
          Quality, (4) Service and (5) Compliance.
        </p>
      </div>

      <div className="mb-2">
        <h3 className="pb-1">Key Guidance:</h3>
        <ol className="mb-1 list-decimal leading-6 list-inside pl-6">
          <li>
            The{" "}
            <b>
              <Link href="https://docs.wfp.org/api/documents/WFP-0000106472/download/" target="_blank">
                RPME Technical Guidance
              </Link>
            </b>{" "}
            explains how the RPME monitors the performance of retail shops that have a contractual relationship with WFP
            for CBT and CV operations.
          </li>
          <li>
            The <b>RPME Practical Guidance</b> provides simple-to-follow steps for conducting the RPME assessment using
            the available tools. It will support you throughout all the RPME digital setup:
            <ol className="mb-1 itlaic list-lower-alpha leading-6 list-inside pl-6 mt-1">
              <li>
                <i>How to customise the questionnaire?</i>
              </li>
              <li>
                <i>How to download and prepare the CSV files?</i>
              </li>
              <li>
                <i>How to create your project in MODA?</i>
              </li>
              <li>
                <i>How to download data from the server?</i>
              </li>
              <li>
                <i>How to upload the data to the Data bridges?</i>
              </li>
              <li>
                <i>Where to find the RPME Dashboard?</i>
              </li>
            </ol>
          </li>
        </ol>
      </div>

      <div className="mb-2">
        <h3 className="pb-1">Key Resources &amp; Links:</h3>
        <ol className="mb-1 list-decimal leading-6 list-inside pl-6">
          <li>
            Download the PDF version of the questionnaire{" "}
            <b>
              <Link href="https://docs.wfp.org/api/documents/WFP-0000139458/download/" target="_blank">
                here.
              </Link>
            </b>
          </li>
          <li>
            Download the XLS Form{" "}
            <b>
              <Link href="https://docs.wfp.org/api/documents/WFP-0000139459/download/" target="_blank">
                here.
              </Link>
            </b>
          </li>
          <li>
            Download your Prefill_1_AdminNames.csv file{" "}
            <b>
              <Link href="#">here.</Link>
            </b>
          </li>
          <li>
            Download your Prefill_Admin.csv file{" "}
            <b>
              <Link href="#">here.</Link>
            </b>
          </li>
          <li>
            Link to{" "}
            <b>
              <Link href="https://moda.wfp.org/" target="_blank">
                MODA.
              </Link>
            </b>
          </li>
          <li>
            Link to the{" "}
            <b>
              <Link href="#">RPME Dashboard.</Link>
            </b>
          </li>
        </ol>
      </div>
    </div>
  )
}

export default AboutRpme
